const OBJECT_URL_REVOKE_DELAY_IN_MS = 10_000

const revokeObjectUrlAfterDelay = (url: string) => {
  window.setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY_IN_MS)
}

export const getRedactedPdfFilename = (filename: string) => `${filename.replace(/\.pdf$/i, '')}_Redacted.pdf`

/** Downloads are marked redacted only when the reviewer accepted at least one redaction. */
export const getReviewedPdfFilename = (filename: string, acceptedRedactionCount: number) =>
  acceptedRedactionCount > 0 ? getRedactedPdfFilename(filename) : `${filename.replace(/\.pdf$/i, '')}.pdf`

/** Uppercase first-name and last-name initials, keeping only A-Z. */
export const getNameInitials = (firstName?: string | null, lastName?: string | null) =>
  `${firstName?.charAt(0) ?? ''}${lastName?.charAt(0) ?? ''}`.toUpperCase().replace(/[^A-Z]/g, '')

/**
 * `LyraHealth_<client initials>_<client DOB>_<provider initials>`. The provider is the one whose
 * records are open (the selected provider for supervisors), so exports are easy to route back.
 */
export const getClientRecordsPdfFilename = ({
  clientDetails,
  providerInitials,
}: {
  clientDetails?: { first_name?: string | null; last_name?: string | null; date_of_birth?: string | null }
  providerInitials: string
}) => {
  const clientInitials = getNameInitials(clientDetails?.first_name || 'N', clientDetails?.last_name || 'A')
  const clientDOB = clientDetails?.date_of_birth || ''
  const formattedDOB = clientDOB ? new Date(clientDOB).toISOString().split('T')[0].replace(/-/g, '') : 'UnknownDOB'
  return [`LyraHealth_${clientInitials}_${formattedDOB}`, providerInitials].filter(Boolean).join('_')
}

export const openPdfBlob = (blob: Blob) => {
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
  revokeObjectUrlAfterDelay(url)
}

export const downloadPdfBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename.endsWith('.pdf') ? filename : `${filename}.pdf`
  link.style.display = 'none'
  document.body.appendChild(link)

  try {
    link.click()
  } finally {
    link.remove()
    revokeObjectUrlAfterDelay(url)
  }
}
